// Kleine Soundeffekte per Web Audio API - keine Audiodateien nötig.
let ctx = null;

function getCtx() {
  if (typeof window === "undefined") return null;
  try {
    if (!ctx) {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return null;
      ctx = new AC();
    }
  } catch (e) {
    console.warn("AudioContext nicht verfügbar:", e);
    return null;
  }
  return ctx;
}

export function unlockAudio() {
  try {
    const c = getCtx();
    if (c && c.state === "suspended") {
      c.resume().catch(() => {});
    }
  } catch (e) {
    console.warn("Audio konnte nicht aktiviert werden:", e);
  }
}

function beep(freq, start, dur, type = "sine", peak = 0.09) {
  const c = getCtx();
  if (!c) return;
  const t0 = c.currentTime + start;
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  gain.gain.setValueAtTime(0.0001, t0);
  gain.gain.exponentialRampToValueAtTime(peak, t0 + 0.012);
  gain.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(gain).connect(c.destination);
  osc.start(t0);
  osc.stop(t0 + dur + 0.02);
}

export function playHit() {
  try {
    beep(660, 0, 0.1, "triangle", 0.1);
    beep(990, 0.05, 0.12, "triangle", 0.09);
  } catch (e) {
    console.warn("Sound konnte nicht abgespielt werden:", e);
  }
}

export function playError() {
  try {
    beep(200, 0, 0.18, "sawtooth", 0.08);
    beep(150, 0.06, 0.22, "sawtooth", 0.07);
  } catch (e) {
    console.warn("Sound konnte nicht abgespielt werden:", e);
  }
}

export function playEnd() {
  try {
    beep(523, 0, 0.16, "triangle", 0.09);
    beep(659, 0.16, 0.16, "triangle", 0.09);
    beep(784, 0.32, 0.28, "triangle", 0.1);
  } catch (e) {
    console.warn("Sound konnte nicht abgespielt werden:", e);
  }
}

export function playCountBeep() {
  try {
    beep(440, 0, 0.12, "sine", 0.07);
  } catch (e) {
    console.warn("Sound konnte nicht abgespielt werden:", e);
  }
}
